<template>
<div>
  <v-toolbar class="pr-2 elevation-0 transparent">
    <v-btn to="/dashboard" color="error" icon flat>
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="ml-0 headline">Content</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn to="/content/create" class="mx-2 my-0" color="success" depressed small>
      <v-icon class="mr-1" left small>add</v-icon>
      <span>Create</span>
    </v-btn>
  </v-toolbar>

  <v-layout row wrap justify-center>
    <v-flex class="px-3" xs12>
      <r-crumbs></r-crumbs>
    </v-flex>
    <v-flex class="px-2 pb-3" xs12 sm10>
      <v-layout v-if="loading" row justify-center>
        <v-flex class="text-xs-center py-5 my-5" xs12>
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-layout v-else class="py-3 px-2" row wrap justify-center>
        <v-flex v-if="content.length == 0" class="py-5" xs12>
          <div class="text-xs-center display-3 grey--text text--lighten-1">
            None
          </div>
        </v-flex>
        <v-flex v-else class="px-2 pb-3" xs12 md10>
          <v-expansion-panel class="elevation-0">
            <v-expansion-panel-content class="mb-3" v-for="c, i in content" :key="i">
              <div slot="header">
                <div class="title primary--text">
                  <span><b>{{c.name}}</b></span>
                </div>
              </div>
              <v-card>
                <v-layout row wrap>
                  <v-flex class="pb-1" xs12>
                    <v-btn :to="'/content/' + c.url" class="my-0 ml-3" color="primary" flat small><b>Edit Content</b></v-btn>
                    <v-btn :to="'/content/' + c.url + '/create'" class="my-0" color="success" flat small><b>New Section</b></v-btn>
                  </v-flex>
                  <v-flex class="pb-1 pl-4" xs12>
                    <div>{{c.description}}</div>
                  </v-flex>
                  <v-flex class="pb-2 pl-4" xs12>
                    <v-list class="pt-0">
                      <v-list-tile v-for="s, i in getSections(c.key)" :key="i" @click="" :to="'/content/' + c.url + '/' + s.url" ripple>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            <span>{{s.name}}</span>
                            <v-icon class="ml-2 mb-1" color="primary">chevron_right</v-icon>
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import Crumbs from '../general/Crumbs.vue'
export default {
  components: {
    rCrumbs: Crumbs
  },
  data: () => ({
    loading: false,
    content: []
  }),
  beforeMount () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      this.content = this.$store.getters.content
      this.loading = false
    },
    getSections (contentKey) {
      const sections = [...this.$store.getters.sectionByContent(contentKey)]
      sections.sort((a, b) => {
        return a.name.localeCompare(b.name, undefined, {numeric: true, sensitivity: 'base'})
      })
      return sections
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/content/ContentList.vue